module.exports = __webpack_public_path__ + "static/media/kettle.fd5b117a.svg";